import {createContext, useState} from 'react';
import LoginPage from "../../components/LoginPage.js";

export const UserContext = createContext(null);

export const UserProvider = (props) => {
    const [user] = useState(props.user);
    return (
        <UserContext.Provider value={user}>
            {!user ?
                <LoginPage login={props.login}/>
                :
                props.children
            }
        </UserContext.Provider>
    );
};
